import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	Typography,
	IconButton,
	Checkbox
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import StarIcon from '@material-ui/icons/Star';

import useQueryParams from '../../hooks/useQueryParams';
import useMainContext from '../../hooks/useMainContext';
import useDiaryData from '../../hooks/useDiaryData';
import useSnackbarText from '../../hooks/useSnackbarText';

import todoes from '../../api/todoes';

const actionWrapperWidth = 50;

const useStyles = makeStyles(theme => ({
	root: {
		minHeight: 50,
		display: 'flex',
		borderBottom: `1px solid #e0e0e0`
	},
	timeSection: {
		display: 'flex',
		flexDirection: 'column',
		//width: '50%',
		minWidth: 100,
		marginTop: 5,
		marginBottom: 5,
		alignItems: 'center',
		justifyContent: 'center',
	},
	itemSection: {
		cursor: 'pointer',
		width: 'calc(100% - 100px)',
		paddingLeft: 13,
		paddingRight: 10,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		//flex: 1
	},
	title: {
		fontSize: 16,
	},
	status: {
		fontSize: 10,
		color: '#929292',
		display: 'flex',
		alignItems: 'center',
	},
	detailWrapper: {
		width: `calc(100% - ${actionWrapperWidth}px)`,
	},
	actionWrapper: {
		width: actionWrapperWidth,
	},
	starIcon: {
		fontSize: 15,
		marginRight: 3,
		fill: `#ffc200`,
	},
}));

function TodoItem(props) {
	const classes = useStyles();
	const { 
		todoID,
		name,
		isChecked,
		remarks
	} = props.details;
	const [checked, setChecked] = useState(isChecked);

	// eslint-disable-next-line
	const [diary, _, handleSetDate, handleManualFetch] = useDiaryData();
	const handleSnackbarChange = useSnackbarText();

	// eslint-disable-next-line
	const [queryParams, setQueryParams] = useQueryParams();
	const { handleChange: handleMainContextChange } = useMainContext();

	const handleClick = () => {
		setQueryParams({ 'update-todo': todoID });
		handleMainContextChange({
			todoDetailUpdate: props.details,
		});
	};

	const handleToggle = async () => {
		setChecked(!Boolean(checked));
		const { success, data } = await todoes.updateTodoChecked({
			todoID: todoID,
			isChecked: !Boolean(checked)
		})

		if(!success) {
			setChecked(Boolean(checked));
			return handleSnackbarChange({ text: data.message, variant: 'error' });
		} 

		//handleSnackbarChange({ text: 'To do list updated', variant: 'success' });
		handleManualFetch();
	};

	return (
		<div className={classes.root}>
			<div className={classes.timeSection} onClick={handleToggle}>
				<Checkbox color="primary" checked={checked} />
			</div>
			<div className={classes.itemSection}>
				<div className={classes.detailWrapper} onClick={handleToggle}>
					<Typography className={classes.name} noWrap>
						{name}
					</Typography>
					<div className={classes.status}>
						{remarks && <StarIcon className={classes.starIcon} />}
						{remarks}
					</div>
				</div>
				<div className={classes.actionWrapper}>
					<IconButton onClick={handleClick}>
						<MoreVertIcon />
					</IconButton>
				</div>
			</div>
		</div>
	);
}

export default TodoItem;
